import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./i9n_item_ref_sort_fields.js";
//#region src/i9n_item_ref_sort_fields_helper.ts
var i9n_item_ref_sort_fields_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(sortField) {
	switch (sortField) {
		case 0: return "Uncategorized (Alphabetical)";
		case 1: return "Name Starts With...";
		case 2: return "Selected by Default";
	}
}
//#endregion
export { i9n_item_ref_sort_fields_helper_exports, name };

//# sourceMappingURL=i9n_item_ref_sort_fields_helper.js.map